import * as React from 'react';
import ScrollableAnchor from 'react-scrollable-anchor';
// import YoutubePlayer from 'react-youtube-player';
import { Col, Container, Row } from 'reactstrap';
import './ProductList.css';

export interface IProductListProps {
    product_list: any;
    image_path: string;
    colors: any;
}

const ProductImage = ({ product, image_path }: any) => (
    <img src={image_path + product.image} style={{ width: '100%' }} className='ProductImage align-self-center' />
);

const ProductDetails = ({ product, colors, specification }: any) => (
    <div className='ProductDetailsBlock'>
        <h2
            className='ProductName'
            style={{
                color: colors.secondary,
                fontWeight: 700,
                lineHeight: 1.5
            }}
        >
            <div>{product.name}</div>
            <div className='ProductCode'>{product.code}</div>
        </h2>
        {!!product.youtube ? (
            <div className='YoutubeBlock'>
                <iframe
                    frameBorder={0}
                    width='100%'
                    height='100%'
                    src={`https://www.youtube.com/embed/${product.youtube}`}
                    // allow='autoplay; encrypted-media'
                    allowFullScreen={true}
                />
                {/* <YoutubePlayer
                    videoId={product.youtube}
                    playbackState='unstarted'
                /> */}
            </div>
        ) : null}
        <ul style={{ listStyleType: 'none' }}>
            {product.description.map((d: string, i: number) => (
                <li
                    className='ProductDescription'
                    key={i}
                    style={{
                        color: colors.dark
                    }}
                >
                    {d}
                </li>
            ))}
        </ul>
        <h3 className='ProductSpecificationTitle' style={{ color: colors.primary, fontWeight: 700 }}>{specification}</h3>
        <ul style={{ listStyleType: 'none' }}>
            {product.specification.map((d: string, i: number) => (
                <li
                    className='ProductDescription'
                    key={i}
                    style={{
                        color: colors.dark
                    }}
                >
                    {d}
                </li>
            ))}
        </ul>
    </div>
);

export class ProductList extends React.Component<IProductListProps, any> {

    public productRefs: any = {};

    public constructor(props) {
        super(props);
    }

    // public scrollToProduct = (wait: number) => {
    //     const code = location.hash.slice(1).toLocaleLowerCase().replace(/-/, '');
    //     const el: any = document.getElementById(code);
    //     if (el) {
    //         setTimeout(() => window.scrollTo(el, el.offsetTop), wait);
    //     }
    // };

    // public componentWillMount() {
    //     window.addEventListener('hashchange', (e) => {
    //         e.preventDefault();
    //         this.scrollToProduct(1);
    //     });
    // }

    // public componentDidMount() {
    //     this.scrollToProduct(2000);
    // }

    public render() {
        const { props } = this;
        return (
            <div style={{ margin: 20 }}>
                <Container
                    className='ProductListContainer'
                    style={{
                        background: 'rgba(255, 255, 255, 0.65)',
                        borderRadius: 20,
                        margin: '30px auto',
                        maxWidth: 970,
                        padding: 16,
                    }}
                >
                    {props.product_list.items.map((x: any, i: number) => (
                        <ScrollableAnchor key={i} id={x.hash}>
                            <div>
                                <Row>
                                    <Col md={i % 2 === 0 ? 5 : 7} className={`d-flex justify-content-center ProductItem order-${i % 2 === 0 ? 1 : 2} order-md-${i % 2 === 0 ? 1 : 2}`}>
                                        {i % 2 === 0 ? (
                                            <ProductImage
                                                image_path={props.image_path}
                                                product={x}
                                            />
                                        ) : (
                                                <ProductDetails
                                                    product={x}
                                                    colors={props.colors}
                                                    specification={props.product_list.specification}
                                                />
                                            )}
                                    </Col>
                                    <Col md={i % 2 === 0 ? 7 : 5} className={`d-flex justify-content-center ProductItem order-${i % 2 === 0 ? 2 : 1} order-md-${i % 2 === 0 ? 1 : 2}`}>
                                        {i % 2 !== 0 ? (
                                            <ProductImage
                                                image_path={props.image_path}
                                                product={x}
                                            />
                                        ) : (
                                                <ProductDetails
                                                    product={x}
                                                    colors={props.colors}
                                                    specification={props.product_list.specification}
                                                />
                                            )}
                                    </Col>
                                </Row>
                            </div>
                        </ScrollableAnchor>
                    ))}
                </Container>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/pages/Home/ProductList/index.tsx